// extracted by mini-css-extract-plugin
export default {"wrapper":"banner-module--wrapper--ffc51","title":"banner-module--title--01f80"};